import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentService } from '@app/shared/services';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'auto-naming-form-model',
  templateUrl: './auto-naming-form-model.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoNamingFormModelComponent implements OnInit, OnDestroy {
  auto_naming_disabled = true;
  enable = true;
  currentFormId;
  subscription = new Subscription();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<AutoNamingFormModelComponent>,
    private cd: ChangeDetectorRef,
    private _documentService: DocumentService
  ) {}
  onToggleClick(event) {
    this.cd.detectChanges();
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  ngOnInit(): void {
    this.currentFormId = this.data.currentFormId;
    this.enable = !this.data.auto_naming_disabled;
  }
  save() {
    this.subscription.add(
      this._documentService
        .disableAutoNaming({
          id: this.currentFormId,
          auto_naming_disabled: !this.enable,
        })
        .subscribe((res) => {
          this.dialogRef.close({
            success: true,
            auto_naming_disabled: !this.enable,
          });
        })
    );
  }
  close() {
    this.dialogRef.close({
      success: false,
    });
  }
}
